import React, { useState, useEffect, useRef } from 'react';
import SvgGear from '../../svg/Gear';

/**
 * A generic dropdown menu wrapper component
 *
 */

const DropdownMenu = (props) => {
  const {
    additionalStyles,
    buttonStyles = '',
    children,
    menuButton = (
      <SvgGear height="20px" width="20px" className="margin-5 pointer-none" />
    ),
    reverseIcon,
  } = props;
  const node = useRef();
  const [showMenu, setShowMenu] = useState(false);

  /**
   * Function to close the quick actions menu when the user clicks outside of the menu
   * @param {object} event - Click event
   * @fires setShowMenu - Sets the "showMenu" state value to false to hide the menu
   */
  const handleClickOutside = (event) => {
    if (node.current.contains(event.target)) {
      // inside click
      return;
    }
    // outside click
    setShowMenu(false);
  };

  /**
   * Function to add and remove an event listener for the menu to close it when the user clicks outside of the menu
   * @description - This uses the React Hooks useEffect to add lifecycle methods to the functional component
   */
  useEffect(() => {
    if (showMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showMenu]);

  /**
   * Function to toggle showing and hiding the menu by clicking the button
   * @fires setShowMenu - Updates local state to set if the dropdown should be shown or hidden
   */
  const toggleMenu = (event) => {
    if (event.target.id === 'dropdown-button') {
      event.preventDefault();
    }
    setShowMenu(!showMenu);
  };

  return (
    <div
      open={showMenu}
      className="dropdown-menu__container dropdown-menu__reset">
      <details open={showMenu} onClick={toggleMenu} ref={node}>
        <summary
          id="dropdown-button"
          data-test="dropdown-button"
          className={
            reverseIcon
              ? 'dropdown-menu__menu-button dropdown-menu__menu-button--reversed ' +
                buttonStyles
              : 'dropdown-menu__menu-button ' + buttonStyles
          }>
          {menuButton}
        </summary>

        <ul
          ref={node}
          data-test="dropdown-list"
          className={'dropdown-menu__menu-container ' + additionalStyles}>
          {children}
        </ul>
      </details>
    </div>
  );
};

export default DropdownMenu;
